import React from 'react';
import { Menu, MenuItem } from '@blueprintjs/core';
import './UserMenuPopover.css';

const ReportMenuPopover = ({ history, location, match, userType }) => {
  return (
    <Menu>
      <MenuItem
        text="Daily Summary"
        onClick={() => history.push('/dailySummary', { from: location.pathname })}
      />
      <MenuItem 
        text="Umpire Statistics" 
        onClick={() => history.push('/reports/umpire/statistics', { from: location.pathname })}
      />
      {userType === 'Admin' && (
        <div>
          <MenuItem 
            text="Team Volunteers" 
            onClick={() => history.push('/reports/team/status', { from: location.pathname })}
          />
          <MenuItem 
            text="YTD Summary" 
            onClick={() => history.push('/reports/summary', { from: location.pathname })}
          />
        </div>
      )}
    </Menu>
  );
};

export default ReportMenuPopover;



// WEBPACK FOOTER //
// ./src/components/ReportsMenuPopOver.js